import { GenerateInvoiceDocumentDocument } from '@/api/queries';
import { GenerateInvoiceDocumentInput } from '@/models/gen/graphql';
import graphApi from '@/api';

const [, runGenerateInvoiceDocument] = graphApi(GenerateInvoiceDocumentDocument);

const generateInvoiceDocument = async (invoiceId: number) => {
  const input: GenerateInvoiceDocumentInput = {
    invoiceId,
  };
  const res = await runGenerateInvoiceDocument({ input });
  return res?.generateInvoiceDocument?.invoiceDocument;
};

export default generateInvoiceDocument;
